import { Grid } from '@material-ui/core'
import InputLabel from '@material-ui/core/InputLabel'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import React from 'react'

export const AutoCompleteFonctionTableur = ({ valeur, options, setValeur, label, inputValue }) => (
  <Grid item xs={12}>
    <InputLabel id="funciton_name_label">{label}</InputLabel>
    {inputValue ? (
      <Autocomplete
        value={valeur}
        inputValue={inputValue}
        options={options}
        getOptionLabel={f => f}
        style={{ width: '100%' }}
        onChange={(e, value) => {
          setValeur(value)
        }}
        renderInput={params => {
          return <TextField {...params} />
        }}
      />
    ) : (
      <Autocomplete
        value={valeur}
        options={options}
        getOptionLabel={f => f}
        style={{ width: '100%' }}
        onChange={(e, value) => {
          setValeur(value)
        }}
        renderInput={params => {
          return <TextField {...params} />
        }}
      />
    )}
  </Grid>
)
